import createSlideshow from '../modules/slideshow/create_slideshow';

export default function () {
    createSlideshow('.article-wrapper .inline-carousel, .article-wrapper .caption-list, .slideshow', false, false);
}
